import React from 'react';
import { Card } from './ui/card';
import { CheckCircle, XCircle, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const comparisonData = {
  without: [
    "Higher risk of workplace accidents",
    "Potential OSHA fines up to $156,259",
    "Increased workers' compensation costs",
    "Low employee morale and high turnover",
    "Legal liability exposure",
    "Failed compliance audits"
  ],
  with: [
    "45% reduction in workplace incidents",
    "Full OSHA compliance confidence",
    "Lower insurance premiums",
    "Improved employee confidence & retention",
    "Protected from legal issues",
    "Pass inspections with ease"
  ]
};

const ComparisonTable = ({ onEnroll }) => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-12">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider">The Difference</span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mt-2 mb-4">
            With vs. Without Safety Training
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            See the real impact proper OSHA training has on your workplace
          </p>
        </div>

        {/* Comparison cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
          {/* Without training */}
          <Card className="p-6 bg-white border-2 border-red-100 rounded-2xl">
            <div className="text-center mb-6">
              <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-3">
                <XCircle className="w-8 h-8 text-red-500" />
              </div>
              <h3 className="text-xl font-bold text-slate-900">Without Training</h3>
              <p className="text-red-600 text-sm">Risk & liability exposure</p>
            </div>
            <ul className="space-y-3">
              {comparisonData.without.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </Card>

          {/* With training */}
          <Card className="p-6 bg-white border-2 border-emerald-200 rounded-2xl shadow-lg relative">
            {/* Recommended badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2">
              <span className="bg-emerald-500 text-white text-xs font-bold px-4 py-1 rounded-full">
                RECOMMENDED
              </span>
            </div>
            
            <div className="text-center mb-6">
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-3">
                <CheckCircle className="w-8 h-8 text-emerald-500" />
              </div>
              <h3 className="text-xl font-bold text-slate-900">With WSafe AI™ Training</h3>
              <p className="text-emerald-600 text-sm">Protected & compliant</p>
            </div>
            <ul className="space-y-3">
              {comparisonData.with.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </Card>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={onEnroll}
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-6 text-lg rounded-xl shadow-lg shadow-emerald-500/25 transition-all duration-300 hover:shadow-emerald-500/40 hover:-translate-y-0.5"
          >
            Start Free Training Now
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          <p className="text-slate-500 text-sm mt-3">No credit card required • Instant access</p>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
